import script from "./infoText.vue?vue&type=script&setup=true&lang=ts"
export * from "./infoText.vue?vue&type=script&setup=true&lang=ts"

import "./infoText.vue?vue&type=style&index=0&id=e9fefb58&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9fefb58"]])

export default __exports__